export const captialize   = string => string.charAt(0)
  .toUpperCase() + string.slice(1);
export const clamp        = (value, min, max) => Math.min(Math.max(value, min), max);
export const distanceTo   = (pointA, pointB) => Math.sqrt((pointB.x - pointA.x) ** 2 + (pointB.y - pointA.y) ** 2);
export const isDefined    = value => typeof value !== 'undefined' && value !== null;
export const isNumber     = value => typeof value === 'number';
export const isObject     = value => typeof value === 'object' && value !== null;
export const length       = (numA, numB) => Math.abs(numA - numB);
export const isMultiValue = value => isObject(value);

export const getPercentageFromValue    = (value, min, max) => {
  const valid      = clamp(value, min, max);
  const diff       = max - min;
  const percentage = (valid - min) / diff;

  return percentage || 0;
};
export const getPercentageFromPosition = (pos, slider) => {
  const percentage = pos.x / slider.width;

  return percentage || 0;
};
export const getPercentagesFromValues  = (value, min, max) => {
  return {
    min: getPercentageFromValue(value.min, min, max),
    max: getPercentageFromValue(value.max, min, max),
  };
};

export const getValueFromPosition = (pos, min, max, slider) => {
  const percentage = getPercentageFromPosition(pos, slider);
  const diff       = max - min;

  return min + diff * percentage;
};
export const getValueFromProps    = (value, minValue) => {
  if (true === isMultiValue(value)) {
    return { ...value };
  }
  return {
    min: minValue,
    max: value,
  };
};

export const getPositionFromValue   = (value, min, max, slider) => {
  const val = getPercentageFromValue(value, min, max);

  return {
    x: val * slider.width,
    y: 0,
  };
};
export const getPositionFromEvent   = (event, slider) => {
  const { clientX } = event.touches ? event.touches[0] : event;

  return {
    x: clamp(clientX - slider.left, 0, slider.width),
    y: 0,
  };
};
export const getPositionsFromValues = (value, min, max, slider) => {
  return {
    min: getPositionFromValue(value.min, min, max, slider),
    max: getPositionFromValue(value.max, min, max, slider),
  };
};

export const getStepValueFromValue = (value, step) => Math.round(value / step) * step;